export default class TopBanner {
  url: string;
  imageUrl: string;

  constructor(data?: Partial<TopBanner>) {
    Object.assign(this, data);
  }
}
